import { ServiceType } from '@uipath/portal-shell-util';

export function getSpaceName() {
    const services = Object.values(ServiceType).map(name => name.toLowerCase());
    const pathName = window.location.pathname.toLowerCase();
    let msiName = '';

    for (let i = 0; i < services.length; i++) {
        const name = services[i];
        if (pathName.indexOf(`/${name}_/`) > -1 || pathName.endsWith(`/${name}_`)) {
            return name;
        }
        if (pathName.startsWith(`/${name}/`) || pathName === `/${name}`) {
            msiName = name;
        }
    }

    return msiName;
}

export function getAccountName() {
    if (!getSpaceName()) {
        return undefined;
    }
    const firstPart = window.location.pathname.split('/')[1];
    return !firstPart?.endsWith('_') ? firstPart : undefined;
}

export function getTenantName() {
    if (!getSpaceName()) {
        return undefined;
    }
    const secondPart = window.location.pathname.split('/')[2];
    return !secondPart?.endsWith('_') ? secondPart : undefined;
}

export function getBaseUrl() {
    return window.location.origin;
}
